import React, { useContext } from 'react';
import { SendBirdContext } from './../Components/SendBirdProvider';

function useSendBird() {
    const SendBird = useContext(SendBirdContext);
    return SendBird;
}

export default useSendBird;
